var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.breakUpdatePermission)?_c('div',{attrs:{"id":"page-user-edit"}},[_c('vx-card',[(_vm.breakData !== null)?_c('break-edit-tab',{staticClass:"mt-4",attrs:{"dataBreak":_vm.breakData}}):_vm._e()],1)],1):_c('not-permission')
}
var staticRenderFns = []

export { render, staticRenderFns }